/**
 * Root App component. Composition only — no business logic here.
 */
import { useReloadDiagnostics } from "@/shared/lib/useReloadDiagnostics";
import { AppProviders } from "@/app/providers";
import { AppRouter } from "@/app/router";

export function App(): JSX.Element {
  // Dev/preview-only: attributes any page reload to the source (HMR, browser
  // reload, or React remount). Compiled out in production.
  useReloadDiagnostics();
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}
